export default __webpack_public_path__ + "static/media/wordmark.d443dafa.svg";